"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "serle": {
    "2e671961": [{
      "hkey": "30663efc",
      "slug": "berana",
      "name": "Berana",
      "primary": true,
      "skipSearch": false
    }],
    "biciocca": [{
      "hkey": "30663efc",
      "slug": "berana",
      "name": "Berana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "serle"
    }],
    "1a933ccd": [{
      "hkey": "a59e0427",
      "slug": "serle",
      "name": "Serle",
      "primary": true,
      "skipSearch": false
    }],
    "bornidolo": [{
      "hkey": "a59e0427",
      "slug": "serle",
      "name": "Serle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c58eef55": [{
      "hkey": "a59e0427",
      "slug": "serle",
      "name": "Serle",
      "primary": true,
      "skipSearch": false
    }],
    "casella": [{
      "hkey": "a59e0427",
      "slug": "serle",
      "name": "Serle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e9663916": [{
      "hkey": "a59e0427",
      "slug": "serle",
      "name": "Serle",
      "primary": true,
      "skipSearch": false
    }],
    "chiesa": [{
      "hkey": "a59e0427",
      "slug": "serle",
      "name": "Serle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0ecdc340": [{
      "hkey": "89db7eeb",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "cocca": [{
      "hkey": "89db7eeb",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "serle"
    }],
    "b4559bab": [{
      "hkey": "a59e0427",
      "slug": "serle",
      "name": "Serle",
      "primary": true,
      "skipSearch": false
    }],
    "gurale": [{
      "hkey": "a59e0427",
      "slug": "serle",
      "name": "Serle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fb659e4c": [{
      "hkey": "89db7eeb",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "magrena": [{
      "hkey": "89db7eeb",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "serle"
    }],
    "309fc8ca": [{
      "hkey": "a59e0427",
      "slug": "serle",
      "name": "Serle",
      "primary": true,
      "skipSearch": false
    }],
    "ronco": [{
      "hkey": "a59e0427",
      "slug": "serle",
      "name": "Serle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "86cfbab7": [{
      "hkey": "a59e0427",
      "slug": "serle",
      "name": "Serle",
      "primary": true,
      "skipSearch": false
    }],
    "salvadine": [{
      "hkey": "a59e0427",
      "slug": "serle",
      "name": "Serle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a5359370": [{
      "hkey": "a59e0427",
      "slug": "serle",
      "name": "Serle",
      "primary": true,
      "skipSearch": false
    }],
    "sorsolo": [{
      "hkey": "a59e0427",
      "slug": "serle",
      "name": "Serle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f22507a9": [{
      "hkey": "a59e0427",
      "slug": "serle",
      "name": "Serle",
      "primary": true,
      "skipSearch": false
    }],
    "tesio-sopra": [{
      "hkey": "a59e0427",
      "slug": "serle",
      "name": "Serle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5a9cd88d": [{
      "hkey": "a59e0427",
      "slug": "serle",
      "name": "Serle",
      "primary": true,
      "skipSearch": false
    }],
    "tesio-sotto": [{
      "hkey": "a59e0427",
      "slug": "serle",
      "name": "Serle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1dbde2a2": [{
      "hkey": "89db7eeb",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "villa": [{
      "hkey": "89db7eeb",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "serle"
    }]
  }
};
exports["default"] = _default;